import React from 'react';

import { margin } from '@lumapps/classnames';
import { EmptyState } from '@lumapps/lumx-states/components/EmptyState';
import { mdiClose } from '@lumapps/lumx/icons';
import { Emphasis, Size } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { useNavigationListFiltersDispatch } from '../../context/NavigationListFiltersContext';
import { actions } from '../../ducks/navigationAdminFilterSlice';

/**
 * State displayed in the navigation admin when the list is filtered
 * and no items matches the filer.
 */
export const EmptyFilteredState = () => {
    const dispatch = useNavigationListFiltersDispatch();
    const { translateKey } = useTranslate();

    return (
        <EmptyState
            wrapperProps={{
                className: margin('vertical', 'regular'),
                gap: Size.tiny,
            }}
            title={translateKey(GLOBAL.NO_RESULT_FOR_THIS_FILTER)}
            buttonProps={{
                leftIcon: mdiClose,
                onClick: () => dispatch(actions.resetFilter()),
                emphasis: Emphasis.medium,
                children: translateKey(GLOBAL.CLEAR),
                className: margin('top', 'regular'),
            }}
            message={translateKey(GLOBAL.TRY_ANOTHER_FILTER)}
        />
    );
};
